import { ChangeDetectorRef, Component, ElementRef, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { AuthService } from 'src/app/_services/auth.service';
import { Router } from '@angular/router';
import { TranslationHelperService } from 'src/app/services/translation-helper/translation-helper.service';
import { ThemeService } from '../../../services/theme/theme.service';
import { UserModel } from 'src/app/_models/User/UserModel';
import { Subscription } from 'rxjs';
import { TokenStorageService } from 'src/app/_services/token-storage.service';
import { MatDialog, MatDialogConfig } from "@angular/material/dialog";
import { SwitchLanguageDialogComponent } from '../../switch-language-dialog/switch-language-dialog.component';
import { FaqComponent } from '../../faq/faq.component';
import { ApiService } from 'src/app/_services/api.service';
import { JwtHelperService } from '@auth0/angular-jwt';
import { RoleTypeEnum } from 'src/app/admin-panel/enums/role-type.enum';
import { HttpErrorResponse } from '@angular/common/http';
import { OverlayPanel } from 'primeng/overlaypanel';
import { environment } from 'src/environments/environment';
import { ApplicationId } from 'src/app/admin-panel/enums/applicationids.enum';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss']
})
export class HeaderComponent implements OnInit, OnDestroy {

  isLoggedin: boolean = false;
  isAdvertiser: boolean = false;
  isTechSupport: boolean = false;

  public imageSrc: string = ''
  public imageAlt: string = ''

  public user?: UserModel
  private userSub?: Subscription;
  firstName: string = '';
  lastName: string = '';
  company: string | undefined = '';
  imagePath: string = "";
  rememberme: any;

  productList: Array<any> = new Array<any>();

  @ViewChild('menu_products', { static: false }) menuProducts: OverlayPanel;
  @ViewChild('icon', { static: false }) toggleBtn: ElementRef;

  constructor(
    private authService: AuthService,
    private apiService: ApiService,
    public router: Router,
    private translationHelperService: TranslationHelperService,
    private themeService: ThemeService,
    private tokenStorage: TokenStorageService,
    private dialog: MatDialog,
    private _jwtHelperService: JwtHelperService,
    public elementRef: ElementRef,
    private changeDetectorRef: ChangeDetectorRef,
  ) { }

  ngOnInit(): void {
    this.imageSrc = "/assets/images/logo/SOCIALITE-Logo-for-dark-background.png";
    this.imageAlt = "Socialite logo";
    this.authService.isLoggedIn$.subscribe((result) => {
      this.isLoggedin = result
      if (this.isLoggedin) {
        this.getUser();
      }
    });
    this.authService._isAdvertiser$.subscribe((result)=>{
      this.isAdvertiser = result;
    })
    this.authService._isTechSupport$.subscribe((result)=>{
      this.isTechSupport = result;
    })
    this.getAllProducts();
  }

  getAllProducts(): void {
    // todo: fetch products
    // test
    this.productList = [
      {
        id: ApplicationId.SocialitePOS.toString(),
        name: "Socialite POS",
        pictureUrl: "./assets/images/temporary/socialite-pos-logo.png",
        url: environment.URLPos
      },
      {
        id: ApplicationId.SocialiteResy.toString(),
        name: "Socialite Resy",
        pictureUrl: "./assets/images/temporary/socialite-resy-logo.png",
        url: environment.URLResy
      },
      ];
  }

  goToProductUrl(url: string){
    const search = '/';
    const replaceWith = '%2F';
    let refreshToken = localStorage.getItem("auth-refreshtoken");
    if(refreshToken){
       const result = (localStorage.getItem("auth-refreshtoken") as string).split(search).join(replaceWith);
       window.location.href = url+"/login/"+result;
    }
  }

  goToDashboard() {
    const search = '/';
    const replaceWith = '%2F';
    let refreshToken = localStorage.getItem("auth-refreshtoken");
    if(refreshToken){
       const result = (localStorage.getItem("auth-refreshtoken") as string).split(search).join(replaceWith);
       window.location.href = environment.URLSocialiteManager+"/login/"+result;
    }
  }

  getUser() {
    this.userSub = this.authService.user.subscribe(user => {
      this.user = new UserModel(
        user?.address,
        user?.businessTypes,
        user?.canReceiveNotifications,
        user?.companyId,
        user?.companyName,
        user?.taxNumber,
        user?.user
      );
      this.company = user?.companyName
      if (user !=undefined && user?.user !=undefined && user.user.firstName && user.user.lastName ) {
        this.firstName = user.user.firstName
        this.lastName = user.user.lastName
        if (user?.user?.profilePictureUrl) {
          this.imagePath = user?.user?.profilePictureUrl
        } else {
          this.imagePath = './assets/images/icons/profile-picture-placeholder.png';
        }
      }
    });
  }

  OpenChangeLanguage() {
    const dialogConfig = new MatDialogConfig();

    dialogConfig.panelClass = 'custom-modal';

    dialogConfig.disableClose = true;
    dialogConfig.autoFocus = true;

    const dialogRef = this.dialog.open(SwitchLanguageDialogComponent, dialogConfig);
  }

  changeActiveTheme(value: string): void {
    this.themeService.changeActiveTheme(value);
  }

  OpenFAQ() {
    const dialogConfig = new MatDialogConfig();

    dialogConfig.panelClass = 'custom-modal-large';

    dialogConfig.disableClose = true;
    dialogConfig.autoFocus = true;

    const dialogRef = this.dialog.open(FaqComponent, dialogConfig);
  }

  OpenPrivacyPolicy() {
    this.router.navigate(['./privacy-policy']);
  }

  signOut() {
    this.rememberme = false
    if (window.localStorage.getItem('rememberme') == 'true') {
      this.rememberme = true
    }
    const token = this.tokenStorage.getToken();
    if (token != null) {
      var tokenDecoded = this._jwtHelperService.decodeToken(token);
      if (tokenDecoded.ustp == RoleTypeEnum.Admin) {
        this.apiService.signOutAdmin(this.rememberme).subscribe((response) => {
          if (response) {
            this.isLoggedin = false;
            this.authService.logout();
            // this.tokenStorage.signOut();
          }
        },(error: HttpErrorResponse) =>{
          if(error.message.includes('token is expired')){
            this.isLoggedin = false;
            this.authService.logout();
          }
        });
      }
      else {
        this.apiService.signOut(this.rememberme).subscribe((response) => {
          if (response) {
            this.isLoggedin = false;
            this.authService.logout();
            // this.tokenStorage.signOut();
          }
        },(error: HttpErrorResponse) =>{
          if(error.message.includes('token is expired')){
            this.isLoggedin = false;
            this.authService.logout();
          }
        });
      }
    }
  }

  ngOnDestroy(): void {
    if (this.userSub !== undefined) {
      this.userSub.unsubscribe();
    }
  }
}
